import React from 'react';
import { Asterisk } from '@nextiva/engagement-ui';

import styles from './RichTextRequiredAsterisk.scss';

const RichTextRequiredAsterisk = () => <Asterisk className={styles.asterisk} />;

export default RichTextRequiredAsterisk;
